import { ContenidoStatus } from './../../../../../common/contenido';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Contenido } from 'src/common/contenido';
import { ContenidoActions, ContenidoActionTypes, ContenidoPageLoaded } from './contenido.actions';


export interface ContenidoState extends EntityState<Contenido> {
	ready: boolean;
	nextPageNum: number;
	pageSize: number;
	morePagesToLoad: boolean;
	status: ContenidoStatus;
	cleared: boolean;
}

export const contenidoAdapter: EntityAdapter<Contenido> = createEntityAdapter<Contenido>();

const initialContenidoState: ContenidoState = contenidoAdapter.getInitialState({
	ready: true,
	nextPageNum: 0,
	pageSize: 3,
	morePagesToLoad: false,
	status: null,
	cleared: false
});

export function contenidoReducer( state: ContenidoState = initialContenidoState, action: ContenidoActions ): ContenidoState {
	let payload;
	let status: ContenidoStatus;

	switch( action.type ) {
		case ContenidoActionTypes.ContenidoPageRequested:
			return { ...state, cleared: false, ready: false };
		case ContenidoActionTypes.ContenidoPageLoaded:
			payload = action["payload"];
			let cleared: boolean = payload["cleared"];
			status = payload["status"];
			let nextPageNum: number = payload["nextPageNum"];
			let contenido: Contenido[] = payload["contenido"];

			if( cleared )
				state = contenidoAdapter.removeAll( state );

			return contenidoAdapter.addMany( contenido, {
				...state,
				ready: true,
				nextPageNum,
				status,
				cleared,
				morePagesToLoad: status.qty - state.ids.length - contenido.length > 0
			});
		case ContenidoActionTypes.ContenidoPageCancelled:
			payload = action["payload"];
			status = payload["status"];
			
			// Si status == null => hubo un problema con el status, dejo el state como está
			if( status != null && status.qty == 0 ) {
				state = contenidoAdapter.removeAll( state );
				state = { ...state, cleared: false, status, morePagesToLoad: false };
			}

			return { ...state, ready: true };
		case ContenidoActionTypes.ContenidoPageRight:
			return { ...state, ready: true, cleared: false };
		default:
			return state;
	}
}

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = contenidoAdapter.getSelectors();



